import axios from 'axios';
import _ from 'lodash';
import { CORE_API } from '../env.config.js';

const fetchLanguages = async (coreTokenObject) => {
  const { token } = coreTokenObject;
  const baseURL = CORE_API;
  const coreConfig = {
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Application-Source': 'widgets',
    },
    params:{
      sort: 'name',
    },
  };

  const response = await axios.get(
    'languages',
    coreConfig,
  );

  return response.data.data;
};

export default fetchLanguages;
